module.exports = __webpack_public_path__ + "static/media/natalie-portman-lesb.563542ac.jpg";